

export function displayName(firstName = '', lastName = '', first_last = true) {
	if(first_last === false) {
		return lastName + ', ' + firstName;
	} else {
		return firstName + ' ' + lastName;
	}
}

export function formatNumber(num) {
  return num.toFixed(0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

export function displayPhone(phoneString) {
  if(!phoneString) {
    return '';
  }

	let digitString = stringToDigits(phoneString);
	return (digitString.slice(0, 3) + '.' + digitString.slice(3, 6) + '.' + digitString.slice(6, 10));
}

export function displayPhoneInput(phoneString) {
	let digitString = stringToDigits(phoneString);
	if(digitString.length <= 3) {
		return digitString;
	} else if(digitString.length <= 6) {
		return (digitString.slice(0, 3) + '-' + digitString.slice(3, 6));
	} else {
		return (digitString.slice(0, 3) + '-' + digitString.slice(3, 6) + '-' + digitString.slice(6, 10));
	}
}

export function displayDateFromTimestamp(timestampString) {
  let d = new Date(timestampString);
  if(d.getTimezoneOffset() > 0) {
    return (d.getMonth() + 1) + '/' + (d.getDate() + 1) + '/' + d.getFullYear();  
  } else {
    return (d.getMonth() + 1) + '/' + (d.getDate()) + '/' + d.getFullYear();  
  }
}

export function displayDatetimeFromTimestamp(timestampString) {
  let d = new Date(timestampString);
  // if(d.getTimezoneOffset() > 0) {
  //   return (d.getMonth() + 1) + '/' + (d.getDate() + 1) + '/' + d.getFullYear();  
  // } else {
  //   return (d.getMonth() + 1) + '/' + (d.getDate()) + '/' + d.getFullYear();  
  // }

  let hours = d.getHours();
  let suffix = 'a';

  if(hours >= 12) {
    hours = hours - 12;
    suffix = 'p';
  }

  if(hours === 0) {
    hours = 12;
  }

  let displayMinutes = d.getMinutes();
  if(displayMinutes < 10) {
    displayMinutes = '0' + displayMinutes;
  }

  return (d.getMonth() + 1) + '/' + (d.getDate()) + '/' + d.getFullYear() + '  ' + hours + ':' + displayMinutes + suffix;
}

export function displaySimpleDate(dateString) {
  return dateString;
}

export function displayVerboseDateFromTimestamp(timestampString) {
	let d = new Date(timestampString);
	let monthNames = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
	return (monthNames[d.getMonth()] + ' ' + d.getDate() + ', ' + d.getFullYear());
}

export function displayDateInput(dateString) {

	let digitString = stringToDigits(dateString);

  let allZeros = true;
  if(digitString.length > 3) {
    for(const ch of digitString) {
      if(ch !== '0') {
        allZeros = false;
        break;
      }
    }
  } else {
    allZeros = false;
  }

  if(allZeros) {
    return '';
  }

	if(digitString.length <= 2) {
		return digitString;
	} else if(digitString.length < 4) {
		return (digitString.slice(0, 2) + '/' + digitString.slice(2, 4));
	} else {
		return (digitString.slice(0, 2) + '/' + digitString.slice(2, 4));
	}
}

export function breaksToBrs(withBreaks, params = {}) {
  if(!withBreaks) {
    return '';
  }

  // return withBreaks;
  let respString = '';
  let styleString = '';

  if(params.margin) {
    styleString += `margin: ${params.margin}; `;
  }

  const lineArray = withBreaks.split(/(?:\r\n|\r|\n)/g);
  for(const ln of lineArray) {
    if(params.blankLines) {
      respString += ln === '' ? `<div style='${styleString}'>&nbsp;</div>` : `<div style='${styleString}'>${ln}</div>`;
    } else {
      respString += ln === '' ? '' : `<div style='${styleString}'>${ln}</div>`;
    }
  }
  return respString;
}

export function displayTimeFromTimestamp(timestampString) {
	let d = new Date(timestampString);
	let hour = d.getHours();
	let suffix = ' AM';
	if(hour > 12) {
		hour -= 12;
		suffix = ' PM';
	}
	if(hour === 0) {
		hour = 12;
	}
	let minutes = d.getMinutes() < 10 ? '0' + d.getMinutes() : d.getMinutes();

	return (hour + ':' + minutes + suffix);
}

export function stringToDigits(testString) {
  if(!testString) { return ''; }
	return testString.replace( /[^0-9]/g, '');
}

export function roleName(roleKey) {
	switch(roleKey) {
		case 'SY':
			return 'System Administrator';
    case 'VP':
      return 'Vice President';
		case 'SA':
			return 'Sales Associate';
		case 'BO':
			return 'Back Office';
		case 'GM':
			return 'General Manager';
		default:
			return '';
	}
}

export function formatShape(diamond) {
  switch (diamond.shape) {
    case 'ROUNDS':
      return 'Round';
    case 'OVALS':
      return 'Oval';
    case 'EMERALD':
      return 'Emerald';
    case 'PEAR SHAPE':
      return 'Pear';
    case 'CUSHION':
      return 'Cushion';
    case 'SQUARE OR PRINCESS':
      return 'Princess';
    case 'RADIANT':
      return 'Radiant';
    case 'MARQUISE':
      return 'Marquise';
    case 'ASCHER':
      return 'Asscher';
    case 'HEART SHAPE':
      return 'Heart';
    case "L'AMOUR CUT":
      return "L'Amour Cut";
    case 'DAUSSI CUSHION':
      return 'Daussi';
    default:
      return '';
  }
}

export function formatCarat(diamond) {
	return parseFloat(diamond.carat_weight).toFixed(2);
}

export function formatRatio(diamond) {
  if(!diamond.ratio) {
    return '';
  }
  return parseFloat(diamond.ratio).toFixed(2);
}

export function formatPrice(diamond) {
	return "$" + parseFloat(diamond.price).toFixed(0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

export function formatCost(diamond) {
  if(!diamond.cost) {
    return '';
  }
  return "$" + parseFloat(diamond.cost).toFixed(0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

export function formatCut(diamond) {
  if(diamond.shape !== 'ROUNDS') {
    return 'N/A';
  }
	return diamond.cut;
}

export function formatColor(diamond) {
	return diamond.color;
}

export function formatClarity(diamond) {
	return diamond.clarity;
}

export function formatSymmetry(diamond) {
	return diamond.symmetry;
}

export function formatPolish(diamond) {
	return diamond.polish;
}

export function formatFluorescence(diamond) {
  return diamond.flourescence;
}

export function formatMeasurements(diamond) {
	let tempMeasurements = diamond.measurements.replaceAll('-', 'x').replaceAll('*', 'x');
	return tempMeasurements.toLowerCase().substring(0,25)
}

export function formatLocation(diamond) {
	switch (diamond.location) {
    case 1:
      return 'Charlotte';
    case 2:
      return 'Headquarters';
    case 3:
      return 'Birmingham';
    case 4:
      return 'Raleigh';
    case 5:
      return 'Austin';
    case 6:
      return 'Richmond';
    case 7:
      return 'Charleston';
    case 8:
      return 'Oklahoma City';
    case 9:
      return 'Virginia Beach';
    case 10:
      return 'San Antonio';
    case 11:
      return 'Dallas';
    case 12:
      return 'Indianapolis';
    case 13:
      return 'St. Louis';
    case 14:
      return 'Jacksonville';
    case 15:
      return 'Salt Lake City';
    case 16:
      return 'Columbus';
    case 17:
      return 'Cleveland';
    case 18:
      return 'Frisco';
    case 19:
      return 'Kansas City';
    case 20:
      return 'New Orleans';
    case 21:
      return 'Boca Raton';
    case 22:
      return 'Greenville';
    case 23:
      return 'Houston';
    case 24:
      return 'Pittsburgh';
    case 26:
      return 'Tysons';
    case 25:
      return 'Baybrook';
    case 27:
      return 'Troy';
    case 28:
      return 'Schaumburg';
    case 29:
      return 'Oakbrook';
    case 30:
      return 'Rockville';
    case 31:
      return 'Aventura';
    case 32:
      return 'Milwaukee';
    case 33:
      return 'Atlanta';
    case 34:
      return 'Palm Beach';
    case 35:
      return 'Woodlands';
    case 50:
      return 'HQ';
    default:
      return '';
  }
}

export function getLocationId(locationDisplay) {
	switch (locationDisplay) {
    case 'Charlotte':
      return 1;
    case 'Headquarters':
      return 2;
    case 'Birmingham':
      return 3;
    case 'Raleigh':
      return 4;
    case 'Austin':
      return 5;
    case 'Richmond':
      return 6;
    case 'Charleston':
      return 7;
    case 'Oklahoma City':
      return 8;
    case 'Virginia Beach':
      return 9;
    case 'San Antonio':
      return 10;
    case 'Dallas':
      return 11;
    case 'Indianapolis':
      return 12;
    case 'St. Louis':
      return 13;
    case 'Jacksonville':
      return 14;
    case 'Salt Lake City':
      return 15;
    case 'Columbus':
      return 16;
    case 'Cleveland':
      return 17;
    case 'Frisco':
      return 18;
    case 'Kansas City':
      return 19;
    case 'New Orleans':
      return 20;
    case 'Boca Raton':
      return 21;
    case 'Greenville':
      return 22;
    case 'Houston':
      return 23;
    case 'Pittsburgh':
      return 24;
    case 'Tysons':
      return 26;
    case 'Baybrook':
      return 25;
    case 'Troy':
      return 27;
    case 'Schaumburg':
      return 28;
    case 'Oakbrook':
      return 29;
    case 'Rockville':
      return 30;
    case 'Aventura':
      return 31;
    case 'Milwaukee':
      return 32;
    case 'Atlanta':
      return 33;
    case 'Palm Beach':
      return 34;
    case 'Woodlands':
      return 35;
    case 'HQ':
      return 50;
    default:
      return '';
  }
}

export function formatJewelryType(jewelry) {
  switch (jewelry.product_type) {
    case 'BANDS':
      return 'Band';
    case 'COLORED STONES':
      return 'Colored Stone';
    case 'SEMI MOUNTS':
      return 'Semi Mount';
    case 'DIAMOND EARRINGS':
      return 'Diamond Earring';
    case 'DIAMOND NECKLACES':
      return 'Diamond Necklace';
    case 'GOLD':
      return 'Gold';
    case 'WATCHES':
      return 'Watch';
    case 'MISCELLANEOUS MERCHANDISE':
      return 'Misc';
    case 'DIAMONDS':
      return 'Diamond';
    case 'PEARL JEWELRY':
      return 'Pearl Jewelry';
    case 'TENNIS BRACELET':
      return 'Tennis Bracelet';
    default:
      return jewelry.product_type;
  }
}

export function formatDiamondTitle(diamond) {
  return formatShape(diamond) + ' ' + formatCarat(diamond) + ' ' + diamond.color + ' ' + diamond.clarity;
}

export function formatDiamondTitleSku(diamond) {
  return diamond.web_item + ' | ' + formatShape(diamond) + ' ' + formatCarat(diamond) + ' ' + diamond.color + ' ' + diamond.clarity;
}

export function formatDiamondSku(diamond) {
  return diamond.web_item;
}

export function formatTable(diamond) {
  return diamond.table + '%';
}

export function formatDepth(diamond) {
  return diamond.depth + '%';
}

export function getDiamondImage(diamond) {
  if(diamond.laying_ref_code) {
    return 'https://segoma.com/ws/public/GetPhoto/first/4/' + diamond.laying_ref_code;
  } else if(diamond.image) {
    return 'https://s3.amazonaws.com/inv-app-diamond-unprocessed-prod/' + diamond.image;
  } else {
    switch (diamond.shape) {
      case 'ROUNDS':
        return '/img/diamonds/shapes/round.svg';
      case 'OVALS':
        return '/img/diamonds/shapes/oval.svg';
      case 'EMERALD':
        return '/img/diamonds/shapes/emerald.svg';
      case 'PEAR SHAPE':
        return '/img/diamonds/shapes/pear.svg';
      case 'CUSHION':
        return '/img/diamonds/shapes/cushion.svg';
      case 'SQUARE OR PRINCESS':
        return '/img/diamonds/shapes/princess.svg';
      case 'RADIANT':
        return '/img/diamonds/shapes/radiant.svg';
      case 'MARQUISE':
        return '/img/diamonds/shapes/marquise.svg';
      case 'ASCHER':
        return '/img/diamonds/shapes/asscher.svg';
      case 'HEART SHAPE':
        return '/img/diamonds/shapes/heart.svg';
      case "L'AMOUR CUT":
        return '/img/diamonds/shapes/lamour.svg';
      case 'DAUSSI CUSHION':
        return '/img/diamonds/shapes/daussi.svg';
      default:
        return '/img/diamonds/shapes/round.svg';
    }
  }
}

export function getWatchThumbnailImage(watch) {
  if(watch.img1) {
    return 'https://watchimg.diamondsdirect.com/' + watch.img1;
  } else {
    return '/img/watches/watch_icon.svg';
  }
}

export function getDiamondImagePlaceholder(diamond) {
  switch (diamond.shape) {
    case 'ROUNDS':
      return '/img/diamonds/shapes/round.svg';
    case 'OVALS':
      return '/img/diamonds/shapes/oval.svg';
    case 'EMERALD':
      return '/img/diamonds/shapes/emerald.svg';
    case 'PEAR SHAPE':
      return '/img/diamonds/shapes/pear.svg';
    case 'CUSHION':
      return '/img/diamonds/shapes/cushion.svg';
    case 'SQUARE OR PRINCESS':
      return '/img/diamonds/shapes/princess.svg';
    case 'RADIANT':
      return '/img/diamonds/shapes/radiant.svg';
    case 'MARQUISE':
      return '/img/diamonds/shapes/marquise.svg';
    case 'ASCHER':
      return '/img/diamonds/shapes/asscher.svg';
    case 'HEART SHAPE':
      return '/img/diamonds/shapes/heart.svg';
    case "L'AMOUR CUT":
      return '/img/diamonds/shapes/lamour.svg';
    case 'DAUSSI CUSHION':
      return '/img/diamonds/shapes/daussi.svg';
    default:
      return '/img/diamonds/shapes/round.svg';
  }
}

export function dayMonthToDbDate(displayDate) {

  if(!displayDate) {
    return '';
  }

  let dbDate = displayDate.replace('/', '-');
  return `1900-${dbDate}`;
}

export function displayDateMMDD(dateString) {
  if(!dateString || dateString == '00/00/') {
    return 'n/a';
  }

  if(dateString.length != 4) {
    if(dateString[dateString.length - 1] === '/') {
      return dateString.slice(0, -1);
    }
    return dateString;
  }

  return dateString.slice(0, 2) + "/" + dateString.slice(-2);
}

export function getUrlId() {
  const urlSplits = window.location.href.split('/');
  return urlSplits[urlSplits.length - 1];
}

export function stringFormat(stringTemplate, params = {}) {
  let formatResp = stringTemplate;
  for(const param in params) {
    formatResp = formatResp.replaceAll(`{{${param}}}`, params[param]);
  }
  return formatResp;
}

export function generateMediaFilename(file) {

  if(!file) {
    return '';
  }

  const filenameChars = 'abcdefghijklmnopqrstuvwxyz1234567890';
  const filenameLength = 24;

  let filestem = '';
  for(let i = 0; i < filenameLength; i++) {
    filestem += filenameChars.charAt(Math.floor(Math.random() * filenameChars.length));
  }
  const nameArray = file.name.split('.');
  const fileExtention = nameArray[nameArray.length - 1];

  return `${filestem}.${fileExtention}`;
}







